import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const questionsAnswers = [
    {
      question: 'Was ist Tankreinigung und warum ist sie wichtig?',
      answer:
        'Tankreinigung entfernt Ablagerungen und Rückstände, die sich im Laufe der Zeit ansammeln. Dies erhöht die Lebensdauer des Tanks und sorgt für saubere und sichere Lagerung von Stoffen.'
    },
    {
      question: 'Wie oft sollte ein Tank gereinigt werden?',
      answer:
        'Die Häufigkeit der Tankreinigung hängt von der Art des gelagerten Inhalts und den Umgebungsbedingungen ab. In der Regel wird eine Reinigung alle 3-5 Jahre empfohlen.'
    },
    {
      question: 'Was ist Leichter Korrosionsschutz?',
      answer:
        'Leichter Korrosionsschutz ist eine Schutzmaßnahme, um Metalloberflächen vor leichter bis moderater Korrosion zu bewahren. Es wird häufig für Bauteile und Strukturen verwendet, die nicht extremen Bedingungen ausgesetzt sind.'
    },
    {
      question: 'Warum ist die Lackierung von Straßenlaternenmasten wichtig?',
      answer:
        'Die Lackierung schützt die Straßenlaternenmasten vor Witterungseinflüssen und Korrosion, verbessert die Optik und verlängert die Lebensdauer der Masten.'
    },
    {
      question: 'Wie lange dauert eine Tankreinigung?',
      answer:
        'Die Dauer der Tankreinigung hängt von der Tankgröße und dem Verschmutzungsgrad ab. In der Regel dauert sie zwischen einem halben und einem ganzen Tag.'
    }
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index); // Schließt die Antwort, wenn sie bereits aktiv ist
  };

  return (
    <div className="faq-container">
      <h2 className="faq-header">Häufig gestellte Fragen (FAQ)</h2>
      {questionsAnswers.map((item, index) => (
        <div key={index} className="faq-item">
          <div
            className="faq-question"
            onClick={() => toggleAnswer(index)}
          >
            {item.question}
          </div>
          <div className={`faq-answer ${activeIndex === index ? 'open' : ''}`}>
            {item.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
